export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  
  "actions":[
    {
      title: "Edit",
      cls: "edit-shipment-method",
      icon: "pencil",
      disabled:false
    },
    {
      title: "Delete",
      cls: "delete-location",
      icon: "trash",
      disabled:false
 }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/shipmentStringMapping/filter/actionOptions.js